import { useState, useEffect } from "react";
import { FaChevronDown, FaChevronUp, FaBox } from "react-icons/fa";
import { loadOrders } from "../../utils/localStorage";
import { formatPrice } from "../../utils/formatPrice";
import styles from "./OrdersPage.module.css";

const STATUS_LABEL = {
  processing: { label: "處理中",  color: "warning" },
  shipped:    { label: "已出貨",  color: "info"    },
  delivered:  { label: "已送達",  color: "success" },
  cancelled:  { label: "已取消",  color: "danger"  },
};

function OrderRow({ order }) {
  const [open, setOpen] = useState(false);
  const status = STATUS_LABEL[order.status] || STATUS_LABEL.processing;
  const previewImgs = order.items.slice(0, 3);

  return (
    <div className={styles.orderCard}>
      <button
        className={styles.orderHeader}
        onClick={() => setOpen(v => !v)}
        aria-expanded={open}
      >
        <div className={styles.orderMeta}>
          <span className={styles.orderId}>{order.id}</span>
          <span className={styles.orderDate}>
            {new Date(order.createdAt).toLocaleDateString("zh-TW", {
              year: "numeric", month: "long", day: "numeric",
            })}
          </span>
        </div>

        <div className={styles.orderPreview}>
          {previewImgs.map(item => (
            <img
              key={item.productId}
              src={item.image}
              alt={item.name}
              className={styles.previewImg}
            />
          ))}
          {order.items.length > 3 && (
            <span className={styles.moreCount}>+{order.items.length - 3}</span>
          )}
        </div>

        <div className={styles.orderRight}>
          <span className={`${styles.statusBadge} ${styles[status.color]}`}>
            {status.label}
          </span>
          <span className={styles.orderTotal}>{formatPrice(order.total)}</span>
          <span className={styles.chevron}>
            {open ? <FaChevronUp /> : <FaChevronDown />}
          </span>
        </div>
      </button>

      {open && (
        <div className={styles.orderDetail}>
          <div className={styles.items}>
            {order.items.map(item => {
              const unitPrice = item.unitPrice ?? (item.salePrice !== null ? item.salePrice : item.price);
              return (
                <div key={item.productId} className={styles.item}>
                  <img src={item.image} alt={item.name} className={styles.itemImg} />
                  <div className={styles.itemInfo}>
                    <p className={styles.itemName}>{item.name}</p>
                    <p className={styles.itemQty}>×{item.quantity}</p>
                  </div>
                  <span className={styles.itemTotal}>{formatPrice(unitPrice * item.quantity)}</span>
                </div>
              );
            })}
          </div>

          <div className={styles.shipping}>
            <h4 className={styles.shippingTitle}>收件資訊</h4>
            <p><strong>收件人：</strong>{order.shippingInfo.name}</p>
            <p><strong>電話：</strong>{order.shippingInfo.phone}</p>
            <p><strong>Email：</strong>{order.shippingInfo.email}</p>
            <p><strong>地址：</strong>{order.shippingInfo.address}</p>
            <p><strong>付款：</strong>{order.shippingInfo.payment === "credit" ? "信用卡" : "貨到付款"}</p>
            {order.shippingInfo.note && (
              <p><strong>備註：</strong>{order.shippingInfo.note}</p>
            )}
          </div>

          <div className={styles.detailTotal}>
            <span>訂單合計</span>
            <span>{formatPrice(order.total)}</span>
          </div>
        </div>
      )}
    </div>
  );
}

function OrdersPage() {
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    setOrders(loadOrders());
  }, []);

  return (
    <div className={styles.page}>
      <div className={styles.container}>
        <h1 className={styles.title}>訂單紀錄</h1>

        {orders.length === 0 ? (
          <div className={styles.empty}>
            <FaBox className={styles.emptyIcon} />
            <p>還沒有任何訂單</p>
          </div>
        ) : (
          <div className={styles.list}>
            {orders.map(order => (
              <OrderRow key={order.id} order={order} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default OrdersPage;
